import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';

function Seo(props: any){
    const [radioValue, setradioValue] = useState('English')
    const [selectedValue, setSelectedValue] = useState("English");
    const [languagesData, setLanguagesData] = useState([]);
    const [indianlanguagesData, setIndianLanguagesData] = useState([]);
    const [languagesValue, setLanguagesValue] = useState(radioValue);
    const [voicetonesData, setVoicetonesData] = useState([])
    const [voicetonesValue, setVoicetonesValue] = useState('')
    const [writingStylesData,setwritingStylesData] = useState([])
    const [writingStylesValue,setwritingStylesValue] = useState('')
    const [textareaValue, setTextareaValue] = useState('')
    const [seedKeywordValue, setSeedKeywordValue] = useState('')
    const [totalKeywordsValue, setTotalKeywordsValue] = useState(10)
    const [yourKeywordsValue, setYourKeywordsValue] = useState('')
    const [productDescriptionValue, setProductDescriptionValue] = useState('')
    const [totalWordsValue, setTotalWordsValue] = useState(200)
    const [totalHeadlines, setTotalHeadlines] = useState(20)
    const [categoryValue, setCategoryValue] = useState('')
    const [productValue, setProductValue] = useState('')
    const [callToActionValue, setCallToActionValue] = useState('click to purchase product')
    const [yourBusinessValue, setYourBusinessValue] = useState('')
    const [totalCategoriesValue, setTotalCategoriesValue] = useState(10)
    const [descriptionLengthValue, setDescriptionLengthValue] = useState('650 to 750')
    const [totalServicesValue, setTotalServicesValue] = useState(10)
    const [totalAttributesValue, setTotalAttributesValue] = useState(5)
    const [totalPostsValue, setTotalPostsValue] = useState(5)
    const [postContentValue, setPostContentValue] = useState('')
    const [contentValue, setcontentValue] = useState('')
    const [keywordsValue, setKeywordsValue] = useState('')
    const [keyword, setKeyword] = useState('')
    const promptTitle = `# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"${props.templateValue}\"](https://www.stwbot.com/)_\"\n---\n`
    let copyWritingPrompt: any ={
        'Keyword Strategy':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a market research expert that speaks and writes fluent ${languagesValue}. You are an expert in keyword research and can develop a full SEO content plan in fluent ${languagesValue}. "${seedKeywordValue}" is the target keyword for which you need to create a Keyword Strategy &Content Plan. Create a markdown table with a list of ${totalKeywordsValue} closely related keywords for an SEO strategy plan for the main keyword "${seedKeywordValue}". Cluster the keywords according to the top 10 super categories and name the super category in the first column as "Category". There should be a maximum of 6 keywords in a super category. The second column should be called "Keyword" and contain the suggested keyword. The third column will be called "Search Intent" and will show the search intent of the suggested keyword from the following list of intents (commercial, transactional, navigational, informational, local or investigational). The fourth column will be called "Title" and will be catchy and click-bait title to use for an article or blog post about that keyword. The fifth column will be called "Description: and will be a catchy meta description with a maximum length of 160 words. The meta description should ideally have a call to action. Do not use single quotes, double quotes or any other enclosing characters in any of the columns you fill in. Do not self reference. Do not explain what you are doing. Just return your suggestions in the table.`, 
        'Get Search Intent For Keywords':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a keyword research expert that speaks and writes fluent ${languagesValue}. I will give you a long list of keywords, and I want you to classify them by the search intent, whether commercial, transactional, navigational, informational, local or investigational. Once done, please print them out in a markdown table with "Keyword" as the first column, and "Search Intent" as the second. Here are the keywords - ${yourKeywordsValue}`, 
        'Related Keyword Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a keyword research expert that speaks and writes fluent ${languagesValue}. I want you to generate a list of ${totalKeywordsValue} keywords closely related to "${seedKeywordValue}" without duplicating any words. Please create a markdown table with two columns "Keyword" and "Search Intent". The first column should be the keyword you generated, and the second column should be the search intent of the keyword (commercial, transactional, navigational, informational, local or investigational). After the table, please print "List of same keywords separated by commas:". On the next line print the same list of keywords at the bottom separated by commas. Do not repeat yourself. Do not self reference. Do not explain what you are doing.`, 
        'Long-Tail Keyword Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a keyword research expert that speaks and writes fluent ${languagesValue}. I want you to generate a list of ${totalKeywordsValue} long-tail keywords for "${seedKeywordValue}". Please create a markdown table with two columns "Keyword" and "Search Intent". The first column should be the keyword you generated, and the second column should be the search intent of the keyword (commercial, transactional, navigational, informational, local or investigational). After the table, please print "List of same keywords separated by commas:". On the next line print the same list of keywords at the bottom separated by commas. Do not repeat yourself. Do not self reference. Do not explain what you are doing.`,
        'Product Description Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an E-commerce SEO expert copywriter who writes product descriptions that compel users to purchase the products. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. In this task, you will craft a compelling product description for an e-commerce item that I will provide. Your goal is to create three unique content sections for the product description, each focusing on a different set of relevant keywords. Be sure to label each section with an eye-catching subheading that accurately summarizes its content. Your product description should be keyword-rich, informative, and engaging, with a word count of under ${totalWordsValue} words. Your objective is to use emotional language and creative reasoning to persuade potential buyers to purchase the product. Once you have written the product description, please create a bulleted list of ${totalHeadlines} possible H1 headings for the product page. Provide a bulleted list of ${totalKeywordsValue} broad match keywords that you used to create the product description. To further enhance the product page marketing appeal, create a persuasive and professional sounding meta title and description that incorporates similar language to that of the new product summary. The meta title should be between 50 and 60 characters long. The meta description should be between 140 to 150 characters long. This is the e-commerce item - "${productDescriptionValue}"`, 
        'Category Description Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an E-commerce SEO expert copywriter. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. your task is to create a compelling ${totalWordsValue} word product category description in flawless ${languagesValue} based on the category name that I provide. Your focus should be on highlighting the benefits of the products within the category, rather than just listing their features. Avoid using the passive voice and instead use active verbs to create a sense of urgency and excitement. Your goal is to create a category description that engages potential customers and inspires them to make a purchase. Make sure that your description flows smoothly and is easy to understand. It should be written in one line, which means you should avoid long paragraphs and instead break up your text with subheadings and bullet points. At the end of your category description, include a strong call to action that encourages customers to explore the products within the category and make a purchase. This will help to boost engagement and conversions. Overall, your objective is to create a category description that is informative, engaging, and persuasive. By highlighting the benefits of the products within the category and using active language to create a sense of urgency, you can attract and convert potential customers, driving sales and boosting the success of the e-commerce store. Category Name: "${categoryValue}"`, 
        'Landing Page Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. Do not self reference. Do not explain what you are doing. You are an E-commerce SEO expert copywriter. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Your task is to generate a detailed USER PERSONA for a business that sells "${productValue}". First write "User Persona creation for ${productValue}" as the heading. Now create a subheading called "Demographics". Below, you need to create a table with the 2 columns and 7 rows with the following format: Column 1 = Data points (Name, Age, Occupation, Annual income, Marital status, Family situation, Location), Column 2 = Answers for each data point in Column 1. Now create a subheading called "Landing page for selling ${productValue} to the above persona". Below this generate landing page text of around ${totalWordsValue} words using this persona. The landing page needs a headline that grabs attention, highlights the product's value proposition, and entices visitors to learn more. Use action-oriented language, such as "Discover", "Transform" or "Experience."  The landing page copy should be persuasive and informative and highlight the product's benefits and features. Use short paragraphs, bullet points, and subheadings to make it easy to read and scan. Use persuasive language that speaks to your audience's emotions and desires. End the landing page with a clear and prominent CTA to ${callToActionValue}`, 
        'Bulk Titles and Descriptions':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an E-commerce SEO expert copywriter. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. Generate compelling meta titles and meta descriptions for a list of e-commerce products that I will give you. One meta title and one meta description should be generated for every product in the list that I give you. The meta title should not be more than 60 characters long. The meta descriptions should not be longer than 160 characters long. The meta title and meta description should have the product keywords in them. The meta title and meta description should use persuasive language that speaks to the audience's emotions and desires and makes them want to purchase the product. Here are the e-commerce products - "${productValue}".`,
        'Optimize Your Google Business Profile (GMB)':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are the a local SEO &Google My Business SEO expert. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. My business is "${yourBusinessValue}". Print the following heading - "Top GMB Categories". Then please provide me with a table of the best ${totalCategoriesValue} GMB categories that Google currently supports for my business type, along with the category ID. Next, print the following heading - "Top Keywords". Then, please print out a comma-separated sentence of the top ${totalKeywordsValue} local search query keywords that customers of my business would search for. Next please print the following heading - "Business Description". After this, write a long business description that between ${descriptionLengthValue} characters. Make sure to use the search query keywords that you had generated earlier. Next please print the following heading - "Services". After this, please print out a comma-separated list of ${totalServicesValue} services using the search query keywords you had come up with earlier. These services specific to the business that customers are searching for.`, 
        'Attributes for Google Business Profile (GMB)':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are the a local SEO &Google My Business SEO expert. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. My business is "${yourBusinessValue}". Please generate ${totalAttributesValue} attributes to highlight in the Google Business Profile for this business. Use attributes that make this business unique and sets it apart from the competition. Please choose attributes from this comma separated list of official Google Business Profile attributes - "Beach Wheelchairs, Mobility Scooter Rental, Passenger Loading Area, Wheelchair Accessible, Wheelchair Accessible Elevator, Wheelchair Accessible Entrance, Wheelchair Accessible Parking, Wheelchair Accessible Restroom, Wheelchair Accessible Seating, Wheelchair Rental Offerings ( Motorized / Non-Motorized), Bicycles for Rent, Boats for Rent, Game Room, Horseback Riding, Jogging Track Indoors, Scuba Diving, Snorkeling, Water Skiing, Air Conditioning, Airport Shuttle, All-Inclusive, Baggage Storage, Bar Onsite, Beach Access, Bicycle Rack, Booster Seats for Children, Business Center, Cellular Service, Child Care, Concierge, Convenience Store Onsite, Currency Exchange, Dogs Allowed/Welcomes Dogs, Drive-Through, Fitness Center, Fitting Room, Free Breakfast, Gift Wrapping, Golf Course, Good for Kids/Welcomes Children, High Chairs, Hot Tub, In-Room Massages, In-Room Safe, Ironing Service, Laundry Service, Live TV, Massage Services, Mechanic, Meeting Rooms, Newspaper Delivery, Parking Offerings (Free / Paid), Pets Welcome, Photocopying/Fax Service, Public Restroom, Restaurant Onsite, Restroom, Room Service, RV Hookup, Smoke-free Property, Solarium Onsite, Spa Onsite, Steam Bath, Stroller Rental, Swimming Pool Offerings (Indoor / Outdoor), Tennis Court (Indoor / Outdoor), Unisex Restroom, Wake-Up Service, Wi-Fi (Free / Paid), Adults-Only, Family-Friendly/Welcomes Families, LGBT-Friendly, Extended Stay, Family Rooms, Breakfast, Brunch, Catering, Counter Service, Delivery, Dessert, Dinner, Lunch, Order Ahead, Outside Food Allowed, Pay Ahead, Seating, Table Service, Takeout, 3D Movies, Active Military Discounts, All You Can Drink, Bar Games, Cabaret Onsite, Casino Onsite, Doctor Onsite, Family-Led/Owned by Family, Fireplace, Great Live Music/Notable Music Acts, Karaoke/Karaoke Nights, Live Music, Live Performances, Nightclub Onsite, Outdoor Seating, Outdoor Standing Area to Drink, Personal Shoppers, Play Area for Kids, Pool Table, Private Beach, Private Dining Room, Private Events, Rooftop Seating, Serves Local Specialty, Sports/Suitable for Watching Sports, Trivia Night, Veteran-Led/Owned by Veterans, Women-Led/Owned by Women, Activewear/Sells Activewear, Adult Classes, Afternoon Tea, Alcohol/Serves Alcohol, All You Can Eat, Appraisals for Items, Assembly Service, Assisted Listening Devices, Baby Clothing, Baby Furniture, Baby Shoes, Batik Clothing, Beer/Serves Beer, Beginner Classes, Bike Storage, Blowouts, Books, Braille Menu, Brand-name Goods, Bulk Food, Bulk Goods, Buys Used Goods, Car Rental, Car Wash, Cash Advance, Certified Kosher Food (Dairy / Meat / Pareve), Certified Pre-Owned Vehicles, Check Cashing, Coat Check, Cocktails, Coffee, Comfort Food, Craft Beer, Dancing, Diesel Gas, Electronics Recycling, Ethanol-Free Gas, Experience with Thick Curly Hair, Experience with Thick Straight Hair, Experience with Thin Curly Hair, Experience with Thin Straight Hair, Fabric Dyeing, Food/Serves Food, Food at the Bar, Formal Wear, Free Air, Free Water Refills, Full-Service Gas, Furniture/Sells Furniture, Gait Analysis/Offers Gait Analysis Testing, Gift Shop Onsite, Gluten-Free Options, Go for Just Dessert/Acceptable to Just Order Dessert, Grilling/Allows Grilling, Grilling Area Onsite, Hair Coloring, Hair Perms, Halal Food, Happy Hour, Happy Hour Drinks, Happy Hour Food, Hard Cider, Hard Liquor, Help Desk, Hot Tea, In-store Pickup, Installation Service, Jain Vegetarian Food, Jewelry, Kids Classes, Kids Clothing, Kids Consignment, Kids Furniture, Kids Haircuts, Kids Menu, Kids Shoes, Kids Tours, Kids Toys, Kosher Food (Some Meals / Strictly Kosher), Late-night Food, Lingerie, Local Ingredients/Serves Locally Sourced Ingredients, Maternity Clothing, Matinees, Medical Imaging Services, Men's Clothing, Men's Shoes, New Goods, New Vehicles, Oil Change, OK to Just Order Coffee, OK to Just Order Alcohol, Organic Dishes, Organic Products, Paleo Food, Passport Photos Onsite, Petite Clothing, Plus-size Clothing, Prepared Foods, Real Ale/Serves Real Ale, Recreational Classes, Repair Services, Sake/Serves Sake, Salad Bar, Same-Day Delivery, Sarees/Sells Sarees, Sauna Onsite, Service Guarantee, Shave, Sing-Along Screenings, Sleepwear/Sells Sleepwear, Small Plates, Spicy Food, Suits/Sells Suits, Sunday Roast, Swimwear/Sells Swimwear, Tasting Menu, Teen Classes, Teeth Whitening, Tent Camping, Title Loans, Tours for Visually Impaired, Transcripts for Hearing Impaired, Used Goods, Vegetarian Options, Vegetarian Options Only/Only Serves Vegetarian, Wedding Clothing, Wine, Women's Clothing, Women's Shoes, Arabic, Cantonese, Dutch, English, Filipino, French, German, Hindi, Indonesian, Korean, Mandarin, Portuguese, Spanish, Vietnamese, Cash-Only, Checks Accepted, Credit Cards Accepted (American Express / China Union Pay / Diners Club / Discover / JCB / MasterCard / Visa), Debit Cards Accepted, Meal Coupons, NFC Mobile Payments, Tez Mobile Payments, Accepting New Patients, Accepts Reservations, LGBT Friendly, Membership Required, Online Events Calendar, Open Weather Permitting, Reservations Recommended, Reservations Required, Transgender Safespace, Treats Adults, Treats Children, Good for Working on Laptop, Suitable for Wedding"`, 
        'Generate Google Business Profile Posts':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are the a local SEO &Google My Business SEO expert. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. My business is "${yourBusinessValue}". Please create ${totalPostsValue} compelling and long GMB posts written in the ${languagesValue} language. Each post should be between 1000 to 1500 characters long and should include important local SEO and longtail keywords. Please include a strong call to action at the end of each post.`, 
        'Generate Q &A for Google Business Profile':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are the a local SEO &Google My Business SEO expert. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. My business is "${yourBusinessValue}". Please generate ${totalPostsValue} compelling Questions and Answers (Q &A ) that will inform and engage my customers. These questions can be related to the products, services, location, hours of operation, or any other aspect of my business that my customers may want to know about. The Q &A should be consise and informative and include important local SEO and longtail keywords. They should increase customer engagement and build trust with potential customers.`, 
        'Generate GMB Post from Content':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are the a local SEO &Google My Business SEO expert. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. My business is "${yourBusinessValue}". Please create a compelling and long GMB posts written in the ${languagesValue} language from the content that I give you. The post should be between 1000 to 1500 characters long and should include important local SEO and longtail keywords. Please include a strong call to action at the end of each post. The content for the post is "${postContentValue}"`,
        'Meta Title &Description Generator':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are an SEO expert &a good copywriter that speaks and writes fluent ${languagesValue}. ${languagesValue}. ${voicetonesValue && 'You have a '+ voicetonesValue +' tone of voice.'} ${writingStylesValue && 'You have a '+ writingStylesValue +' writing style.'} Do not self reference. Do not explain what you are doing. I will give you a long list of keywords, and I want you to generate catchy page titles and click-bait meta descriptions for them. The page titles should be between 70 and 80 characters. The meta descriptions should be between 140 and 160 characters. Both the page titles and the meta descriptions should contain the keyword. Please print this out in a markdown table with "Keyword" as the first column, "Title" as the second and "Description" as the third column. Here are the keywords - ${yourKeywordsValue}`, 
        'Create Silo Structure':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a keyword research expert that speaks and writes fluent ${languagesValue}. Create a detailed SILO structure for a website using the keyword: "${yourKeywordsValue}". Organize the page of the website in a hierarchical structure, with the Homepage at the top and the more specific pages at the bottom. You need to group, isolate, and interlink pages about a specific topic. Do not repeat yourself. Do not self reference. Do not explain what you are doing. Only write down the SILO pages in a nested structure.`, 
        'Insert Keywords into Content':`${promptTitle}Previous instruction should be ignored. Write in ${languagesValue} language for response. You are a content writer that speaks and writes fluent ${languagesValue}. Please rewrite the content that I give you with minimal number of edits to insert the following keywords into it "${keywordsValue}". Do not repeat yourself. Do not self reference. Do not explain what you are doing. Here is the content - ${contentValue}`
    }
    let templateValue: any = copyWritingPrompt[props.templateValue] ? copyWritingPrompt[props.templateValue] : ''
    useEffect(() => {
        setTextareaValue(templateValue)
    }, [templateValue])
    useEffect(() => {
        resetValue()
    }, [props.templateValue])
    useEffect(() => {
        const data: any = []
        for (const key in indianLanguages) {
            const value: any = {
                name: '',
                value: ''
            }
            value.value = key;
            value.name = indianLanguages[key];
            data.push(value)
        }
        setIndianLanguagesData(data) 
        const dataVoice: any = []
        for (const key in voicetones) {
            const value: any = {
                name: '',
                value: ''
            }
            value.value = key;
            value.name = voicetones[key];
            dataVoice.push(value)
        }
        setVoicetonesData(dataVoice) 
        const datawritingStyles:any = []
        for (const key in writingStyles) {
            const value: any = {
                name: '',
                value: ''
            }
            value.value = key;
            value.name = writingStyles[key];
            datawritingStyles.push(value)
        }
        setwritingStylesData(datawritingStyles)
    },[])
    const onChangeRadio = (event: any) => {
        const value = event.target.value;
        setSelectedValue(value);
        setradioValue(value)
        if(value === 'Other languages'){
            const data: any = []
            for (const key in languages) {
                const value: any = {
                    name: '',
                    value: ''
                }
                value.value = key;
                value.name = languages[key];
                data.push(value)
            }
            setLanguagesData(data)
            setLanguagesValue('Arabic')
        } else {
            setLanguagesValue(value)
            setLanguagesData([])
        }
    }
    const onChangeLanguages = (event: any) => {
        const value = event.target.value;
        setLanguagesValue(value)
    }
    const onChangeVoicetones = (event: any) => {
        const value = event.target.value
        setVoicetonesValue(value)
    }
    const onChangeWritingStyles = (event: any) => {
        const value = event.target.value
        setwritingStylesValue(value)
    }
    const onChangeTextarea = (event: any) => {
        const value = event.target.value
        setTextareaValue(value)
    }
    const onChangeSeedKeyword = (event:any) => {
        const value = event.target.value
        setKeyword(value)
        setSeedKeywordValue(value)
    }
    const onChangeTotalKeywords = (event:any) => {
        const value = event.target.value
        setTotalKeywordsValue(value)
    }
    const onChangeYourKeywords = (event:any) => {
        const value = event.target.value
        setKeyword(value)
        setYourKeywordsValue(value)
    }
    const onChangeProductDescription = (event:any) => {
        const value = event.target.value  
        setKeyword(value)
        setProductDescriptionValue(value)
    }
    const onChangeTotalWords = (event: any) => {
        const value = event.target.value
        setTotalWordsValue(value)
    }
    const onChangeTotalHeadlines = (event: any) => {
        const value = event.target.value 
        setTotalHeadlines(value)
    }
    const onChangeCategory = (event:any) => {
        const value = event.target.value 
        setKeyword(value)
        setCategoryValue(value)
    }
    const onChangeProduct = (event:any) => {
        const value = event.target.value 
        setKeyword(value)
        setProductValue(value)
    }
    const onChangeTotalCategories = (event:any) => {
        const value = event.target.value 
        setTotalCategoriesValue(value)
    }
    const onChangeCallToAction = (event: any) => {
        const value = event.target.value  
        setCallToActionValue(value)
    }
    const onChangeYourBusiness = (event: any) => {
        const value = event.target.value  
        setKeyword(value)
        setYourBusinessValue(value)
    }
    const onChangeDescriptionLength = (event:any) => {
        const value = event.target.value  
        setDescriptionLengthValue(value)
    }
    const onChangeTotalServices = (event:any) => {
        const value = event.target.value  
        setTotalServicesValue(value)
    }
    const onChangeTotalAttributes = (event:any) => {
        const value = event.target.value  
        setTotalServicesValue(value)
    }
    const onChangeTotalPosts = (event:any) => {
        const value = event.target.value
        setTotalPostsValue(value)
    }
    const onChangePostContent = (event:any) => {
        const value = event.target.value
        setPostContentValue(value)
    }
    const onChangeContent = (event:any) => {
        const value = event.target.value
        setcontentValue(value)
    }
    const onChangeKeywords = (event:any) => {
        const value = event.target.value
        setKeyword(value)
        setKeywordsValue(value) 
    }
    const executeTemplateButton = () => {
        props.executeTemplateButton(textareaValue, keyword)
    }
    const getButtonVisiblety = () => {
        const value = props.templateValue
        switch(value) {
            case 'Keyword Strategy':
                return seedKeywordValue && totalKeywordsValue ? false : true
            case 'Get Search Intent For Keywords':
                return yourKeywordsValue ? false : true
            case 'Related Keyword Generator':
                return seedKeywordValue && totalKeywordsValue ? false : true
            case 'Long-Tail Keyword Generator':
                return seedKeywordValue && totalKeywordsValue ? false : true
            case 'Product Description Generator':
                return productDescriptionValue && totalKeywordsValue && totalHeadlines && totalWordsValue ? false : true
            case 'Category Description Generator':
                return categoryValue && totalWordsValue ? false : true
            case 'Landing Page Generator':
                return productValue && totalWordsValue && callToActionValue ? false : true
            case 'Bulk Titles and Descriptions':
                return productValue ? false : true
            case 'Optimize Your Google Business Profile (GMB)':
                return yourBusinessValue && totalCategoriesValue && totalKeywordsValue && descriptionLengthValue && totalServicesValue ? false : true
            case 'Attributes for Google Business Profile (GMB)':
                return yourBusinessValue && totalAttributesValue ? false : true
            case 'Generate Google Business Profile Posts':
                return yourBusinessValue && totalPostsValue ? false : true
            case 'Generate Q &A for Google Business Profile':
                return yourBusinessValue && totalPostsValue ? false : true
            case 'Generate GMB Post from Content':
                return yourBusinessValue && postContentValue ? false : true
            case 'Meta Title &Description Generator':
                return yourKeywordsValue ? false : true
            case 'Create Silo Structure':
                return yourKeywordsValue ? false : true
            case 'Insert Keywords into Content':
                return contentValue && keywordsValue ? false : true
            default:
                return true;
        }
    }
    const resetValue = () => {
        setSeedKeywordValue('')
        setTotalKeywordsValue(10)
        setYourKeywordsValue('')
        setProductDescriptionValue('')
        setTotalWordsValue(200)
        setTotalHeadlines(20)
        setCategoryValue('')
        setProductValue('')
        setCallToActionValue('click to purchase product')
        setYourBusinessValue('')
        setTotalCategoriesValue(10)
        setDescriptionLengthValue('650 to 750')
        setTotalServicesValue(10)
        setTotalAttributesValue(5)
        setTotalPostsValue(5)
        setPostContentValue('')
        setcontentValue('')
        setKeywordsValue('')
    }
    return(
        <div className='marketing'>
            <div className="row">
                <div className="col-sm-12 mt-2"><p>Description: Suggest 10 catchy blog post titles for a specific topic</p></div>
                <div className="col-sm-12 mt-2">
                    <div id="reverse-radio" className="mb-3">
                        {indianlanguagesData.map((item, i) => 
                            <Form.Check
                                key={i}
                                reverse
                                onChange={onChangeRadio}
                                label={item['name']}
                                checked={selectedValue === item['name']}
                                name="group1"
                                value={item['name']}
                                type='radio'
                                id={`reverse-radio-${i}`}
                            />
                        )}
                    </div>
                </div>
                {radioValue === "Other languages" && <div className="col-sm-4 mt-2">
                    <Form.Label htmlFor="languages">Languages:</Form.Label>
                    <Form.Select id="languages" 
                        value={languagesValue}
                        onChange={onChangeLanguages}
                    >
                        {languagesData.map((item, i) => <option key={i} value={item['name']}>{item['name']}</option>)}
                    </Form.Select>  
                </div>}
                {props.templateValue === "Keyword Strategy" ||
                props.templateValue === 'Get Search Intent For Keywords' ||
                props.templateValue === 'Related Keyword Generator' ||
                props.templateValue === 'Long-Tail Keyword Generator' ||
                props.templateValue === "Create Silo Structure" ||
                props.templateValue === "Insert Keywords into Content" ? <></> : <><div className={"col-sm-"+(radioValue === "Other languages" ? "4" : "6")+" mt-2"}>
                    <Form.Label htmlFor="voicetones">Voice Tones:</Form.Label>
                    <Form.Select 
                        id="voicetones" 
                        aria-label="Default"
                        value={voicetonesValue}
                        onChange={onChangeVoicetones}
                    >
                        <option>Default</option>
                        {voicetonesData.map((item, i) => <option key={i} value={item['name']}>{item['name']}</option>)}
                    </Form.Select>  
                </div>
                <div className={"col-sm-"+(radioValue === "Other languages" ? "4" : "6")+" mt-2"}>
                    <Form.Label htmlFor="writingStyles">Writing Styles:</Form.Label>
                    <Form.Select 
                        id="writingStyles" 
                        aria-label="Default"
                        value={writingStylesValue}
                        onChange={onChangeWritingStyles}
                    >
                        <option>Default</option>
                        {writingStylesData.map((item, i) => <option key={i} value={item['name']}>{item['name']}</option>)}
                    </Form.Select>
                </div></>}
                {props.templateValue === 'Keyword Strategy' || 
                props.templateValue === 'Related Keyword Generator' || 
                props.templateValue === 'Long-Tail Keyword Generator' ? <div className="col-sm-10  mt-2">
                    <Form.Label htmlFor="SeedKeyword">Seed Keyword</Form.Label>
                    <Form.Control
                        value={seedKeywordValue}
                        type="text"
                        id="SeedKeyword"
                        aria-describedby="Seed Keyword"
                        onChange={onChangeSeedKeyword} 
                    />
                </div> : <></>}
                {props.templateValue === 'Optimize Your Google Business Profile (GMB)' || 
                props.templateValue === "Attributes for Google Business Profile (GMB)" || 
                props.templateValue === "Generate Google Business Profile Posts" || 
                props.templateValue === "Generate Q &A for Google Business Profile" ||
                props.templateValue === "Generate GMB Post from Content" ? <div 
                    className={"col-sm-" + (
                        props.templateValue === "Attributes for Google Business Profile (GMB)" || 
                        props.templateValue === "Generate Google Business Profile Posts" ||
                        props.templateValue === "Generate Q &A for Google Business Profile" ? "10" : "12"
                        )+ " mt-2"}
                >
                    <Form.Label htmlFor="yourBusiness">Your Business</Form.Label>
                    <Form.Control 
                        id="yourBusiness"
                        value={yourBusinessValue}
                        onChange={onChangeYourBusiness}
                        as='textarea' 
                        rows={2}
                    />
                </div> : <></>}
                {props.templateValue === "Generate GMB Post from Content" ? <div 
                    className="col-sm-12 mt-2"
                >
                    <Form.Label htmlFor="PostContent">Post Content</Form.Label>
                    <Form.Control 
                        id="PostContent"
                        value={postContentValue}
                        onChange={onChangePostContent}
                        as='textarea' 
                        rows={2}
                    />
                </div> : <></>}
                {props.templateValue === 'Category Description Generator' ? <div className="col-sm-10  mt-2">
                    <Form.Label htmlFor="Category">Category</Form.Label>
                    <Form.Control
                        value={categoryValue}
                        type="text"
                        id="Category"
                        aria-describedby="Category"
                        onChange={onChangeCategory} 
                    />
                </div> : <></>}
                {props.templateValue === 'Landing Page Generator' || 
                props.templateValue === "Bulk Titles and Descriptions" ? <div className="col-sm-12  mt-2">
                    {props.templateValue === "Bulk Titles and Descriptions" ? <>    <Form.Label htmlFor="Product">Product</Form.Label>
                        <Form.Control
                            value={productValue}
                            as='textarea'
                            rows={3}
                            id="Product"
                            aria-describedby="Product"
                            onChange={onChangeProduct} 
                        />
                    </> : <>
                        <Form.Label htmlFor="Product">Product</Form.Label>
                        <Form.Control
                            value={productValue}
                            type="text"
                            id="Product"
                            aria-describedby="Product"
                            onChange={onChangeProduct} 
                        />
                    </>}
                </div> : <></>}
                {props.templateValue ===  "Product Description Generator" && <div className="col-sm-10  mt-2">
                    <Form.Label htmlFor="productServiceDescription">Product Description:</Form.Label>
                    <Form.Control 
                        id="productServiceDescription"
                        value={productDescriptionValue}
                        as='textarea' 
                        rows={3}
                        onChange={onChangeProductDescription}
                    />
                </div>}  
                {props.templateValue === "Generate Google Business Profile Posts" || props.templateValue === "Generate Q &A for Google Business Profile" ? <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="TotalPosts">Total Posts: </Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalPostsValue}
                        id="TotalPosts"
                        aria-describedby="Total Posts"
                        onChange={onChangeTotalPosts}
                    />
                </div> : <></>}
                {props.templateValue === 'Attributes for Google Business Profile (GMB)' ? <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="TotalAttributes">Total Attributes: </Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalAttributesValue}
                        id="TotalAttributes"
                        aria-describedby="Total Attributes"
                        onChange={onChangeTotalAttributes}
                    />
                </div> : <></>}
                {props.templateValue === 'Optimize Your Google Business Profile (GMB)' ? <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="totalCategories">Total Categories: </Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalCategoriesValue}
                        id="totalCategories"
                        aria-describedby="Total Categories"
                        onChange={onChangeTotalCategories}
                    />
                </div> : <></>}
                {props.templateValue === 'Keyword Strategy' || 
                props.templateValue === 'Related Keyword Generator' ||
                props.templateValue === 'Long-Tail Keyword Generator' ||
                props.templateValue ===  "Product Description Generator" || 
                props.templateValue === 'Optimize Your Google Business Profile (GMB)' ? <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="totalKeywords">Total Keywords: </Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalKeywordsValue}
                        id="totalKeywords"
                        aria-describedby="Total Keywords"
                        onChange={onChangeTotalKeywords}
                    />
                </div> : <></>}
                {props.templateValue === 'Optimize Your Google Business Profile (GMB)' ? <div className="col-sm-6  mt-2">
                    <Form.Label htmlFor="descriptionLength">Description Length: </Form.Label>
                    <Form.Control
                        type="text"
                        value={descriptionLengthValue}
                        id="descriptionLength"
                        aria-describedby="Description Length"
                        onChange={onChangeDescriptionLength}
                    />
                </div> : <></>}
                {props.templateValue === 'Optimize Your Google Business Profile (GMB)' ? <div className="col-sm-2  mt-2">
                    <Form.Label htmlFor="totalServices">Total Services: </Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalServicesValue}
                        id="totalCategories"
                        aria-describedby="Total Services"
                        onChange={onChangeTotalServices}
                    />
                </div> : <></>}
                {props.templateValue ===  "Product Description Generator" ? <div className="col-sm-6  mt-2">
                    <Form.Label htmlFor="totalHeadlines">Total Headlines</Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalHeadlines}
                        id="totalHeadlines"
                        aria-describedby="Total Headlines"
                        onChange={onChangeTotalHeadlines}
                    />
                </div> : <></>}
                {props.templateValue === 'Product Description Generator' || 
                props.templateValue === 'Category Description Generator' || 
                props.templateValue === 'Landing Page Generator' ? <div className={"col-sm-"+(props.templateValue === 'Category Description Generator' ? "2" : "6")+"  mt-2"}>
                    <Form.Label htmlFor="totalTitles">Total Words: </Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        max={1000}
                        value={totalWordsValue}
                        id="totalWords"
                        aria-describedby="Total Words"
                        onChange={onChangeTotalWords}
                    />
                </div> : <></>}
                {props.templateValue === "Insert Keywords into Content" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="Content">Content</Form.Label>
                    <Form.Control 
                        id="Content"
                        value={contentValue}
                        onChange={onChangeContent}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "Insert Keywords into Content" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="keywords">Keywords</Form.Label>
                    <Form.Control 
                        id="keywords"
                        value={keywordsValue}
                        onChange={onChangeKeywords}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === 'Get Search Intent For Keywords' ||
                props.templateValue === "Meta Title &Description Generator" ||
                props.templateValue === "Create Silo Structure" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="yourKeywords">Your Keywords</Form.Label>
                    <Form.Control 
                        id="yourKeywords"
                        value={yourKeywordsValue}
                        onChange={onChangeYourKeywords}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === 'Landing Page Generator' && <div className="col-sm-6  mt-2">
                    <Form.Label htmlFor="callToAction">Call To Action </Form.Label>
                    <Form.Control
                        value={callToActionValue}
                        type="text"
                        id="callToAction"
                        aria-describedby="Call To Action "
                        onChange={onChangeCallToAction} 
                    />
                </div>}
                {/* <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="ptemplate">Prompt Template</Form.Label>
                    <Form.Control 
                        id="ptemplate"
                        value={textareaValue}
                        onChange={onChangeTextarea}
                        as='textarea' 
                        rows={10}
                    />
                </div> */}
            </div>
            <div className="row">
                <div className="col-sm-12  mt-2">
                    <Button id="executeTemplate" onClick={executeTemplateButton} disabled={getButtonVisiblety()} >Execute Template</Button>
                </div>
            </div>
        </div>
    )   
}

export default Seo;


const indianLanguages: any = {
    "Assamese":"Assamese",
    "Bengali":"Bengali",
    "Bodo":"Bodo",
    "Dogri":"Dogri",
    "English": "English",
    "Gujarati":"Gujarati",
    "Hindi":"Hindi",
    "Kannada":"Kannada",
    "Kashmiri":"Kashmiri",
    "Konkani":"Konkani",
    "Maithili":"Maithili",
    "Malayalam":"Malayalam",
    "Marathi":"Marathi",
    "Meitei":"Meitei",
    "Nepali":"Nepali",
    "Odia":"Odia",
    "Punjabi":"Punjabi",
    "Sanskrit":"Sanskrit",
    "Santali":"Santali",
    "Sindhi":"Sindhi",
    "Tamil":"Tamil",
    "Telugu":"Telugu",
    "Urdu":"Urdu",
    "Other languages": "Other languages"
}

const languages: any = {
    "arabic": "Arabic",
    "bulgarian": "Bulgarian",
    "burmese": "Burmese",
    "czech": "Czech",
    "danish": "Danish",
    "dutch": "Dutch",
    "french": "French",
    "german": "German",
    "greek": "Greek",
    "hungarian": "Hungarian",
    "indonesian": "Indonesian",
    "italian": "Italian",
    "japanese": "Japanese",
    "javanese": "Javanese",
    "korean": "Korean",
    "mandarin chinese": "Mandarin Chinese",
    "polish": "Polish",
    "portuguese": "Portuguese",
    "romanian": "Romanian",
    "russian": "Russian",
    "spanish": "Spanish",
    "swedish": "Swedish",
    "thai": "Thai",
    "turkish": "Turkish",
    "ukranian": "Ukranian",
    "urdu": "Urdu",
    "vietnamese": "Vietnamese",
    "wu chinese": "Wu Chinese",
    "yue chinese": "Yue Chinese"
}

const voicetones: any = {
    "authoritative": "Authoritative",
    "caring": "Caring",
    "casual": "Casual",
    "cheerful": "Cheerful",
    "coarse": "Coarse",
    "conservative": "Conservative",
    "conversational": "Conversational",
    "creative": "Creative",
    "dry": "Dry",
    "edgy": "Edgy",
    "enthusiastic": "Enthusiastic",
    "expository": "Expository",
    "formal": "Formal",
    "frank": "Frank",
    "friendly": "Friendly",
    "fun": "Fun",
    "funny": "Funny",
    "humorous": "Humorous",
    "informative": "Informative",
    "irreverent": "Irreverent",
    "journalistic": "Journalistic",
    "matteroffact": "Matter of fact",
    "nostalgic": "Nostalgic",
    "objective": "Objective",
    "passionate": "Passionate",
    "poetic": "Poetic",
    "playful": "Playful",
    "professional": "Professional",
    "provocative": "Provocative",
    "quirky": "Quirky",
    "respectful": "Respectful",
    "romantic": "Romantic",
    "sarcastic": "Sarcastic",
    "serious": "Serious",
    "smart": "Smart",
    "snarky": "Snarky",
    "subjective": "Subjective",
    "sympathetic": "Sympathetic",
    "trendy": "Trendy",
    "trustworthy": "Trustworthy",
    "unapologetic": "Unapologetic",
    "upbeat": "Upbeat",
    "witty": "Witty"
}
const writingStyles: any = {
    "academic": "Academic",
    "analytical": "Analytical",
    "argumentative": "Argumentative",
    "conversational": "Conversational",
    "creative": "Creative",
    "critical": "Critical",
    "descriptive": "Descriptive",
    "epigrammatic": "Epigrammatic",
    "epistolary": "Epistolary",
    "expository": "Expository",
    "informative": "Informative",
    "instructive": "Instructive",
    "journalistic": "Journalistic",
    "metaphorical": "Metaphorical",
    "narrative": "Narrative",
    "persuasive": "Persuasive",
    "poetic": "Poetic",
    "satirical": "Satirical",
    "technical": "Technical"
}